export const agreeaArray = [
  '',
  'ilkeä tyyppi',
  'kiistelty henkilö',
  'miellyttävä heppu',
  'sympaattinen kaveri',
  'suosittu kaveri',
]
export const agressArray = [
  '',
  'seesteinen',
  'levollinen',
  'tasapainoinen',
  'temperamenttinen',
  'tulisieluinen',
  'epävakaa',
]
export const honestyArray = [
  '',
  'täysin arvaamaton',
  'epärehellinen',
  'rehellinen',
  'suoraselkäinen',
  'oikeudentuntoinen',
  'pyhimys',
]
export const skillArrayB = [
  'jumalainen',
  'utopinen',
  'maaginen',
  'myyttinen',
  'uskomaton',
  'titaaninen',
  'yliluonnollinen',
  'unohtumaton',
  'armoitettu',
  'häikäisevä',
  'loistava',
  'mahtava',
  'erinomainen',
  'hyvä',
  'kelvollinen',
  'välttävä',
  'heikko',
  'kehno',
  'kurja',
  'surkea',
  'olematon',
]
export const specArray = [
  '-',
  'tekninen',
  'nopea',
  'voimakas',
  'arvaamaton',
  'pääpeli',
  'toipuja',
  'pelle',
  'joukkuepelaaja',
]
export const skillArr = [
  'keeperSkill',
  'defenderSkill',
  'playmakerSkill',
  'wingerSkill',
  'passingSkill',
  'scorerSkill',
  'setPiecesSkill',
]
export const taidot = [
  'Erikoistilanteet',
  'Puolustus',
  'Maaliteko',
  'Laituri',
  'MT+ET',
  'Syöttö',
  'Pelinrakennus',
  'Maalivahti',
  'SY laaj.',
  'PU laaj.',
  'LA laaj.',
]

export const taidotLyh = [
  'ET',
  'PU',
  'MT',
  'LA',
  'MT+',
  'SY',
  'PR',
  'MV',
  'SY+',
  'PU+',
  'LA+',
]

export const skills = [
  'setPiecesSkill',
  'defenderSkill',
  'scorerSkill',
  'wingerSkill',
  'scorerSkill',
  'passingSkill',
  'playmakerSkill',
  'keeperSkill',
  'passingSkill',
  'defenderSkill',
  'wingerSkill',
]

export const translations = {
  keeperSkill: ['Maalivahti', 'Goalkeeper'],
  defenderSkill: ['Puolustus', 'Defending'],
  playmakerSkill: ['Pelinrakennus', 'Playmaking'],
  wingerSkill: ['Laituri', 'Winger'],
  passingSkill: ['Syöttäminen', 'Passing'],
  scorerSkill: ['Maalinteko', 'Scoring'],
  setPiecesSkill: ['Erikoistilanteet', 'Set Pieces'],
  coach: ['Valmentaja', 'Coach'],
  assistants: ['Apuvalmentajat', 'Assistants'],
  intensitety: ['Intensiteetti', 'Intensitety'],
  stamina: ['Kestävyys', 'Stamina'],
  mode: ['Harjoitusmuoto', 'Training mode'],
  intensity: ['Intensiteetti', 'Intensitety'],
  minutes: ['Minuutit', 'Minutes'],
  efficiency: ['Teho (PR innerit 1, laita 0,5)', 'Effiency'],
  effency: ['Teho', 'Efficiency'],
  sessions: ['Harjoituskerrat', 'Sessions'],
  medic: ['Lääkäri', 'Medic'],
  formCoach: ['Kuntovalkku', 'Form Coach'],
}
